'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useMemo, useState } from 'react';
import { Container } from '@/components/elementary/Container';
import { BillingSwitch } from '@/components/page-builder/global/pricingV1/BillingSwitch';
import { FeatureComparison } from '@/components/page-builder/global/pricingV1/featureComparison';
import { FeaturedPlan } from '@/components/page-builder/global/pricingV1/featuredPlan';
import { PlanOverview } from '@/components/page-builder/global/pricingV1/overview';
import { MONTHLY_VISIBLE_PLANS } from '@/constants/pricing.constants';
export function PricingClient(t0) {
  const $ = _c(29);
  const {
    data,
    stickyTopOffset,
    billingSwitchTagImage,
    billingSwitchArrowImage,
    featuredPlan,
    anchorId,
    dataTestId
  } = t0;
  const [yearly, setYearly] = useState(true);
  const [currentTab, setCurrentTab] = useState(data?.[0]?.title ?? "");
  let t1;
  bb0: {
    if (!data) {
      t1 = data;
      break bb0;
    }
    let t2;
    if ($[0] !== data || $[1] !== yearly) {
      t2 = yearly ? data : data.slice(0, MONTHLY_VISIBLE_PLANS);
      $[0] = data;
      $[1] = yearly;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const visibleData = t1;
  let t2;
  if ($[3] !== featuredPlan) {
    t2 = featuredPlan && <FeaturedPlan data={featuredPlan} />;
    $[3] = featuredPlan;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== billingSwitchArrowImage || $[6] !== billingSwitchTagImage || $[7] !== currentTab || $[8] !== data || $[9] !== yearly) {
    t3 = <BillingSwitch data={data} yearly={yearly} setYearly={setYearly} currentTab={currentTab} setCurrentTab={setCurrentTab} tagImage={billingSwitchTagImage} arrowImage={billingSwitchArrowImage} />;
    $[5] = billingSwitchArrowImage;
    $[6] = billingSwitchTagImage;
    $[7] = currentTab;
    $[8] = data;
    $[9] = yearly;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== currentTab || $[12] !== stickyTopOffset || $[13] !== visibleData || $[14] !== yearly) {
    t4 = <PlanOverview data={visibleData} yearly={yearly} currentTab={currentTab} setCurrentTab={setCurrentTab} stickyTopOffset={stickyTopOffset} />;
    $[11] = currentTab;
    $[12] = stickyTopOffset;
    $[13] = visibleData;
    $[14] = yearly;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== currentTab || $[17] !== visibleData || $[18] !== yearly) {
    t5 = <FeatureComparison data={visibleData} yearly={yearly} currentTab={currentTab} setCurrentTab={setCurrentTab} />;
    $[16] = currentTab;
    $[17] = visibleData;
    $[18] = yearly;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div className="pt-11.25 pb-22.5 bg-brand-black"><Container paddingX={true}>{t3}{t4}{t5}</Container></div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== anchorId || $[25] !== dataTestId || $[26] !== t2 || $[27] !== t6) {
    t7 = <div id={anchorId} data-test-id={dataTestId}>{t2}{t6}</div>;
    $[24] = anchorId;
    $[25] = dataTestId;
    $[26] = t2;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}